import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

/** Multiple Items **/

export function purchaseRebateItemsHasErrored(bool) {
  return {
    type: 'PURCHASE_REBATE_ITEMS_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function purchaseRebateItemsIsLoading(bool) {
  return {
    type: 'PURCHASE_REBATE_ITEMS_IS_LOADING',
    isLoading: bool,
  };
}
export function purchaseRebateItemsFetchDataSuccess(items) {
  return {
    type: 'PURCHASE_REBATE_ITEMS_FETCH_DATA_SUCCESS',
    items,
  };
}

/** Single Item **/

export function purchaseRebateItemHasErrored(bool) {
  return {
    type: 'PURCHASE_REBATE_ITEM_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function purchaseRebateItemIsLoading(bool) {
  return {
    type: 'PURCHASE_REBATE_ITEM_IS_LOADING',
    isLoading: bool,
  };
}
export function purchaseRebateItemFetchDataSuccess(item) {
  return {
    type: 'PURCHASE_REBATE_ITEM_FETCH_DATA_SUCCESS',
    item,
  };
}

/** Multiple Secondary Item **/

export function purchaseRebateProductItemsHasErrored(bool) {
  return {
    type: 'PURCHASE_REBATE_PRODUCT_ITEMS_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function purchaseRebateProductItemsIsLoading(bool) {
  return {
    type: 'PURCHASE_REBATE_PRODUCT_ITEMS_IS_LOADING',
    isLoading: bool,
  };
}
export function purchaseRebateProductItemsFetchDataSuccess(items) {
  return {
    type: 'PURCHASE_REBATE_PRODUCT_ITEMS_FETCH_DATA_SUCCESS',
    items,
  };
}

function buildQueryString(id) {
  let queryString = '';

  queryString += 'offerFunderId=' + id;

  return queryString ? '?' + queryString : queryString;
}

export function purchaseRebateItemsFetchData(id) {
  const queryString = buildQueryString(id);

  const url = queryString
    ? apiEndPoints.PURCHASE_REBATE_LIST + queryString
    : apiEndPoints.PURCHASE_REBATE_LIST;

  return (dispatch) => {
    dispatch(purchaseRebateItemsIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(purchaseRebateItemsIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(purchaseRebateItemsFetchDataSuccess(items)))
      .catch(() => {
        dispatch(purchaseRebateItemsIsLoading(false));
        dispatch(purchaseRebateItemsHasErrored(true));
      });
  };
}

export function getPurchaseRebateItem(id) {
  const url = apiEndPoints.PURCHASE_REBATE_ITEM.replace('id', id);

  return (dispatch) => {
    dispatch(purchaseRebateItemIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        dispatch(purchaseRebateItemIsLoading(false));
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((item) => dispatch(purchaseRebateItemFetchDataSuccess(item)))
      .catch(() => dispatch(purchaseRebateItemHasErrored(true)));
  };
}

export function getPurchaseRebateProduct(id) {
  const url = `${apiEndPoints.PURCHASE_REBATE_PRODUCT_LIST}/${id}`;

  return (dispatch) => {
    dispatch(purchaseRebateProductItemsIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        dispatch(purchaseRebateProductItemsIsLoading(false));
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((item) =>
        dispatch(purchaseRebateProductItemsFetchDataSuccess(item)),
      )
      .catch(() => dispatch(purchaseRebateProductItemsHasErrored(true)));
  };
}
